import React from 'react';
import PropTypes from 'prop-types';
import DateRangeSelector from './DateRangeSelector';
import EventListener from 'react-event-listener';
import Popover from 'material-ui/Popover';
import PopoverAnimationVertical from 'material-ui/Popover/PopoverAnimationVertical';
import injectSheet from 'react-jss';
import styles from 'components/input/DateRange/styles/DateRangeSelectorDialog';
import utils from 'helpers/utils';
import { RaisedButton, FlatButton } from 'material-ui';

// Todo (vishal) make this stateless
class DateRangeSelectorDialog extends React.Component {
    constructor(props) {
        super(props);

        this.dismiss = this.dismiss.bind(this);
        this.handleAccept = this.handleAccept.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.componentDidMount = this.componentDidMount.bind(this);
        this.setRange = this.setRange.bind(this);
        this.state = { anchorEl: null };
    }

    componentDidMount() {
        this.setState({
            anchorEl: this.dialog,
        });
    }

    dismiss() {
        const { onCancel } = this.props;

        if (utils.isFunction(onCancel) && this.props.showDialog) {
            onCancel();
        }
    }

    handleWindowKeyUp(evt) {
        if (evt.key === 'Escape') {
            this.handleCancel();
        }
    }

    handleAccept() {
        const { onAccept } = this.props;

        if (utils.isFunction(onAccept)) {
            onAccept();
        }
    }

    handleCancel() {
        const { onCancel } = this.props;

        if (utils.isFunction(onCancel)) {
            onCancel();
        }
    }

    setRange(rs, re) {
        const { setRange } = this.props;

        if (utils.isFunction(setRange)) {
            setRange(rs, re);
        }
    }

    // Todo (vishal) use calendar action button instead
    render() {
        const {
            DateTimeFormat,
            animation,
            cancelLabel,
            containerStyle,
            customRanges,
            firstMonthDay,
            locale,
            maxDate,
            minDate,
            noOfCalendars,
            okLabel,
            onChange,
            onNextMonthButtonClicked,
            onPrevMonthButtonClicked,
            onReset,
            rangeEnd,
            rangeStart,
            resetLabel,
            sheet,
            shouldDisableDate,
            showDialog,
        } = this.props;

        const { classes } = sheet;

        return (
            <div
                style={ {
                    position: 'relative',
                } }
                ref={ (dialog) => {
                    this.dialog = dialog;
                } }
            >
                <Popover
                    anchorEl={ this.state.anchorEl } // For Popover
                    animation={ animation || PopoverAnimationVertical } // For Popover
                    bodyStyle={ classes.dialogBodyContent }
                    contentStyle={ classes.dialogContent }
                    repositionOnUpdate={ true }
                    open={ showDialog }
                    onRequestClose={ this.dismiss }
                    style={ Object.assign(styles.dialogBodyContent, containerStyle) }
                >
                    <EventListener
                        target='window'
                        onKeyUp={ (evt) => {
                            return this.handleWindowKeyUp(evt);
                        } }
                    />

                    <div className={ classes.mainContainer }>
                        <div className={ classes.customRangeContainer }>
                            <div className={ classes.flexInnerContainer }>
                                <DateRangeSelector
                                    DateTimeFormat={ DateTimeFormat }
                                    locale={ locale }
                                    onTouchTap={ onChange }
                                    rangeStart={ rangeStart }
                                    rangeEnd={ rangeEnd }
                                    minDate={ minDate }
                                    maxDate={ maxDate }
                                    noOfCalendars={ noOfCalendars }
                                    firstMonthDay={ firstMonthDay }
                                    nextMonthButtonClicked={ onPrevMonthButtonClicked }
                                    prevMonthButtonClicked={ onNextMonthButtonClicked }
                                    shouldDisableDate={ shouldDisableDate }
                                />
                            </div>

                            {
                                (customRanges !== undefined && customRanges.length > 0) ?
                                    <div className={ classes.RangeButton }>
                                        <span className={ classes.customrange }>Custom Range</span>

                                        <div className={ classes.dateRangeContainer }>
                                            {
                                                customRanges.map((v, i) => {
                                                    return (
                                                        <div key={ `fbs_${ v.label + i }` } style={ { padding: '2% 0%' } }>
                                                            <FlatButton
                                                                fullWidth={ true }
                                                                label={ v.label }
                                                                onClick={ () => {
                                                                    return this.setRange(v.range[0], v.range[1]);
                                                                } }
                                                            />
                                                        </div>
                                                    );
                                                })
                                            }
                                        </div>
                                    </div>
                                    : ''
                            }
                        </div>

                        <div className={ classes.okButton }>
                            <div>
                                <RaisedButton label={ okLabel } onClick={ this.handleAccept } primary={ true } />
                            </div>

                            <div style={ { margin: '0 2%', paddingBottom: '10px' } }>
                                <RaisedButton label={ cancelLabel } primary={ true } onClick={ this.handleCancel } />
                            </div>

                            {
                                (resetLabel !== undefined) &&
                                <div>
                                    <RaisedButton label={ resetLabel } onClick={ onReset } primary={ true } />
                                </div>
                            }
                        </div>
                    </div>
                </Popover>
            </div>
        );
    }
}

DateRangeSelectorDialog.propTypes = {
    DateTimeFormat: PropTypes.func,
    animation: PropTypes.func,
    cancelLabel: PropTypes.string,
    containerStyle: PropTypes.object,
    customRanges: PropTypes.array,
    firstMonthDay: PropTypes.object.isRequired,
    locale: PropTypes.string,
    maxDate: PropTypes.object,
    minDate: PropTypes.object,
    noOfCalendars: PropTypes.number,
    okLabel: PropTypes.string,
    onAccept: PropTypes.func,
    onCancel: PropTypes.func,
    onChange: PropTypes.func,
    onNextMonthButtonClicked: PropTypes.func.isRequired,
    onPrevMonthButtonClicked: PropTypes.func.isRequired,
    onReset: PropTypes.func,
    rangeEnd: PropTypes.object,
    rangeStart: PropTypes.object,
    resetLabel: PropTypes.string,
    setRange: PropTypes.func,
    sheet: PropTypes.object,
    shouldDisableDate: PropTypes.func,
    showDialog: PropTypes.bool,
};

DateRangeSelectorDialog.contextTypes = {
    muiTheme: PropTypes.object.isRequired,
};

export default injectSheet(styles)(DateRangeSelectorDialog);



// WEBPACK FOOTER //
// ./src/components/input/DateRange/DateRangeSelectorDialog.js